import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sortOlympicPanel'
})
export class SortOlympicPanelPipe implements PipeTransform {

  /**
   * Method for compute the value of event type.
   *
   * @param {*} value The value could be (Individual|Team|Mixed)
   * @returns
   * @memberof SortOlympicPanelPipe
   */
  computeValueEventType(value){
    switch(value){
      case 'Individual':
        return 1;
      case 'Team':
        return 2;
      case 'Mixed':
        return 3;
    }
  }

  /**
   * {@inheritdoc}
   *
   * @param {{olympics:Array<any>}} value
   * @param {...any[]} args
   * @returns {*}
   * @memberof SortOlympicPanelPipe
   */
  transform(value: {olympics:Array<any>}, ...args: any[]): any {
    const sortTable = args[0] as {sort_name:string, order:boolean};
    let sort;
    switch(sortTable.sort_name){
      case 'EDITION':
        sort = value.olympics.sort((f,s)=>{
          const asc = sortTable.order ? 1 : -1;
          const yearFirst = Number(f.Year);
          const yearSecond = Number(s.Year);
          return yearFirst > yearSecond ? asc : -asc;
        });
        break;
      case 'EVENT':
        sort = value.olympics.sort((f,s)=>{
          const asc = sortTable.order ? 1 : -1;
          const valueFirst = this.computeValueEventType(f.Type);
          const valueSecond = this.computeValueEventType(s.Type)
          return valueFirst > valueSecond ? asc : -asc;
        });
        break;
      case 'RESULT':
        sort = value.olympics.sort((f,s)=>{
          const asc = sortTable.order ? 1 : -1;
          const resultFirst =f.Event.Rnk;
          const resultSecond = s.Event.Rnk;
          return resultFirst > resultSecond ? asc : -asc;
        });
        break;
    }
    return sort ? sort : value.olympics;
  }

}
